import { combineReducers } from "redux";
import { activeMenuPath } from "./activeMenuPath";
import { caipNudgeTriggerEvent } from "./caipNudgeTriggerEvent";
import { error } from "./error";
import { isKernelRunning } from "./isKernelRunning";
import { nonfatalErrorMessage } from "./nonfatalErrorMessage";
import { selectedCellHidden, selectedCellOutputHidden, selectedCellType, status, versionsLoadStatus } from "./status";

/** Manages the Jupyter editor state. */
export const editor = combineReducers({
  activeMenuPath,
  error,
  nonfatalErrorMessage,
  isKernelRunning,
  status,
  versionsLoadStatus,
  selectedCellType,
  selectedCellHidden,
  selectedCellOutputHidden,
  caipNudgeTriggerEvent,
});
